<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card  v-can="'view-product-waste-inventory'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Created From</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date From" v-model="filters['from']"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Created To</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date From" v-model="filters['to']"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Disposed from Date</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date From" v-model="filters['disposed-from']"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Disposed to Date</label>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" placeholder="Choose Date From" v-model="filters['disposed-to']"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full mt-4">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="['Disposed', 'Unavailable', 'Inventory Difference', 'QC Rejected', 'Product Expired', 'Available', 'Product Loss - Human error', 'Product Loss - Multiple weight out', 'Assigned to NPD', 'Other', 'Stock Check Adjustments']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card title="RAW MATERIAL WASTE ITEMS">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'rm-waste-sheet'" :filters="filters"/>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              id="raw-material-waste-item-table"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" class="text-sm">WO/STOCK CHECK </vs-th>
                <vs-th width="10%" class="text-sm">QUANTITY (KG)</vs-th>
                <vs-th width="15%" class="text-sm">STATUS</vs-th>
                <vs-th width="10%" class="text-sm">REASON FOR CHANGE</vs-th>
                <vs-th width="20%" class="text-sm">RAW MATERIALS</vs-th>
                <vs-th width="10%" class="text-sm">CREATED AT</vs-th>
                <vs-th width="10%" class="text-sm" >CREATED BY</vs-th>
                <vs-th width="10%" class="text-sm">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-md" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <!-- <vs-td v-if="!data[indextr].dispose_timestamp"></vs-td> -->

                  <vs-td class="cursor-pointer text-primary">
                    <vx-tooltip v-if="!!data[indextr].work_order_id" :text="'View ' + data[indextr].work_order" position="right">
                      <a @click.stop="onClickWorkOrder(data[indextr].work_order_id)">{{ data[indextr].work_order}}</a>
                    </vx-tooltip>
                    <span v-if="!data[indextr].work_order_id">
                      {{ data[indextr].stock_batch_code }}
                    </span>
                    <span v-if="!!data[indextr].raw_material_order_code">
                      {{ data[indextr].raw_material_order_code }}
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].quantity">
                    {{ toFixed(data[indextr].quantity)}}
                  </vs-td>

                  <vs-td class="text-primary" :data="data[indextr].status">
                    <vs-chip transparent :color="['Unavailable', 'Disposed'].includes(tr.status) ? 'danger' : tr.status === 'Available' ? 'primary' : 'warning'">
                      {{ rmWasteStatusFormatter(data[indextr].status) }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].reason || 'N/A' }}
                  </vs-td>

                  <vs-td class="text-primary" >
                    <span v-for="(rm, index) in data[indextr].raw_materials" :key="index">
                      <HyperLink :id="rm.id" :supplier_id="rm.supplier_id" type="raw-material">{{ rm.raw_material }}</HyperLink><span v-if="data[indextr].raw_materials.length-1 !== index">,</span>
                    </span>
                    <span v-if="!!data[indextr].raw_material">
                      {{ data[indextr].raw_material }}
                    </span>
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].created_by || 'N/A' }}
                  </vs-td>

                  <vs-td  v-can="'edit-sundry-item-stock-inventory'">
                    <div class="vx-row">
                      <vx-tooltip v-if="data[indextr].work_order_id" text="View RM waste items" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickStockChange(data[indextr])"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="!['Unavailable', 'Disposed', 'Returned to Stock'].includes(tr.status)" text="Dispose item" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickStatusChange(data[indextr].id)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-zap"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['On Hold'].includes(tr.status)" text="Return to stock" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickReturnToStock(tr)"
                                   size="small" color="success" type="border" icon-pack="feather" icon="icon-rotate-cw"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                  <template class="expand-user" slot="expand" v-if="!!data[indextr].dispose_timestamp">
                    <div class="con-expand-users w-full m-12">
                      Disposed by: <b>{{ data[indextr].disposed_by || 'N/A' }}</b> <br> <br>
                      Disposed date/time: <b>{{ data[indextr].dispose_timestamp || 'N/A' }}</b> <br> <br>
                      Dispose note: <b>{{ data[indextr].dispose_note || 'N/A' }}</b>
                    </div>
                  </template>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <view-raw-material-waste-pop-up ref="viewRawMaterialWastePopUp"/>
    <vs-prompt
      @cancel="status_change_obj={}"
      @accept="changeStatus"
      @close="activePrompt = false"
      :is-valid="isValidReason"
      :title="'Disposed rm waste'"
      :accept-text="'Confirm'"
      :color="'danger'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Dispose note</span>
        <v-select
          :clearable="true" name="name" placeholder=""
          v-model="status_change_obj.dispose_note"
          :options="status_change_reasons"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
        <vs-textarea v-if="status_change_obj.dispose_note === 'Other'" class="mb-0 mt-4" v-model="status_change_obj.dispose_note_other" height="100px" />
      </div>
    </vs-prompt>
    <RmWasteSendBackToStockPopUp ref="rmWasteSendBackToStockPopUp" @refreshData="refreshData()"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const InventoryRepository = RepositoryFactory.get('inventory')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import ViewRawMaterialWastePopUp from "@/components/popups/inventory/stock/ViewRawMaterialWastePopUp";
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import RmWasteSendBackToStockPopUp from '@/components/popups/inventory/stock/RmWasteSendBackToStockPopUp.vue';

  export default {
    name: 'RawMaterialWasteList',
    data () {
      return {
        items: [],
        filters: {},
        status_change_obj: {},
        activePrompt: false,
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        status_change_reasons: [
          'Incinerated', '3rd party waste contractor has taken possession', 'Poured into mains drain',
          'Added to commercial waste', 'Stock Expired', 'Inventory Difference', 'Stock Check Adjustments','Other'
        ],
        status_list: ['Disposed', 'Unavailable', 'Inventory Difference', 'QC Rejected', 'Product Expired', 'Available', 'Product Loss - Human error', 'Assigned to NPD', 'On Hold', 'Returned to Stock']
      }
    },
    components: {
      'v-select': vSelect,
      ViewRawMaterialWastePopUp,
      flatPickr,
      RmWasteSendBackToStockPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
    },
    methods: {
      async refreshData () {
        await this.fetchRawMaterialWasteItemList()
      },
      async fetchRawMaterialWasteItemList() {
        await this.$vs.loading({
          container: '#raw-material-waste-item-table',
          scale: 0.45
        })
        try {
          const {data} = await InventoryRepository.getRawMaterialWasteItemList(this.page, this.filterQuery, this.perPage)
          this.items =  data.data
          this.meta = data.meta
        } catch (e) {

          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#raw-material-waste-item-table > .con-vs-loading')
      },
      onClickStatusChange(id) {
        this.status_change_obj.id = id
        this.activePrompt =  true
      },
      async changeStatus() {
        try {
          await InventoryRepository.disposeRawMaterialWasteItem(
            this.status_change_obj.id,
            {dispose_note: this.status_change_obj.dispose_note !== 'Other' ? this.status_change_obj.dispose_note : this.status_change_obj.dispose_note_other}
          )
          await this.refreshData()
          this.status_change_obj = {}
          this.showSuccessMessage('Raw material waste item disposed successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      toFixed(number) {
        return Number(number).toFixed(4)
      },

      filterQueryUpdate (){
        this.page = 1
        this.fetchRawMaterialWasteItemList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchRawMaterialWasteItemList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchRawMaterialWasteItemList()
        }

      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },
      close(){
        this.activePrompt = false
      },
      onClickStockChange(data) {
        this.$refs.viewRawMaterialWastePopUp.openPopup(data)
      },
      onClickWorkOrder(wo_id) {
        this.$router.push({path: `/pages/manufacturing/work-orders/${wo_id}/details`})
      },
      rmWasteStatusFormatter(status) {
        if(['Unavailable', 'Disposed'].includes(status)) return 'Waste disposed'
        return status
      },
      async onClickReturnToStock(data) {
        this.$refs.rmWasteSendBackToStockPopUp.openPopup(data)
      }
    },
    watch : {
      page(){
        this.fetchRawMaterialWasteItemList()
      },
      perPage() {
        this.fetchRawMaterialWasteItemList()
      }
    },
    computed: {
      isValidReason() {
        if (!this.status_change_obj.dispose_note){
          return false
        }
        return this.status_change_obj.dispose_note.length > 2;
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
